module.exports = "/fonts/vendor/dhx-spreadsheet/codebase/dhxicons-webfont.woff2?1c23ac1f51638d1e8948f23e9ec2e16d";